import React, { useState, useEffect } from 'react'
import { Icon, Pane, Table, Heading, FormField, TextInput, Button, toaster } from 'evergreen-ui'
import to from 'await-to-js'
import axios from '../../Utils/axios';
import * as moment from 'moment'
import { withRouter } from 'react-router-dom'
const Home = ({
  history
}) => {
  const [summary, setSummary] = useState([])

  const [dates, setDates] = useState({
    dateFrom: moment().subtract(10, 'days').format('YYYY-MM-DD'),
    dateTo: moment().format('YYYY-MM-DD')
  })

  const getActivities = async (dateFrom, dateTo) => {

    const [err, res] = await to(axios.get(`/company/activities/summary?fromDate=${encodeURIComponent(moment(dateFrom).format('YYYY-MM-DD 00:00:00'))}&toDate=${encodeURIComponent(moment(dateTo).format('YYYY-MM-DD 23:59:59'))}`))

    if (err) {
      toaster.danger(err.response.data.error.message)
    }

    const summaryFiltred = res.data.summary.filter(empployee => { return empployee.expenses > 0 || empployee.resources > 0})
  
    setSummary(summaryFiltred)
  }

  const setValues = ({ target }) => {

    if (target.name === 'dateFrom' && moment(target.value).diff(dates.dateTo) > 0) {
      return toaster.danger('Data de início não pode ser superior a data de término', {
        duration: 3
      })
    }

    setDates({
      ...dates,
      [target.name]: target.value
    })
  }

  const searchSummary = () => {
    const { dateFrom, dateTo } = dates
    getActivities(moment(dateFrom), moment(dateTo))
  }

  useEffect(() => {
    const { dateFrom, dateTo } = dates
    getActivities(moment(dateFrom), moment(dateTo))
  }, [dates])


  const getTotalActitvities = (activities) => summary.reduce((totalActivities, activity) => totalActivities + activity.resources, 0)
  const getTotalExpenses = (expenses) => summary.reduce((totalExpense, expense) => totalExpense + expense.expenses, 0)

  const totalExpenses = getTotalExpenses(summary)
  const totalActivities = getTotalActitvities(summary)

  return (
    <React.Fragment>
      <Heading size={600} style={{ marginLeft: 10 }}> Consulta de atividade dos Gerentes </Heading>
      <div style={{ marginLeft: 10, marginRight: 10, marginTop: 0, display: 'block' }}>
        <Pane display="flex" padding={16} borderRadius={3}>
          <Pane flex={1} alignItems="center" display="flex">
            <FormField
              label='Data Início'
            >
              <TextInput
                type='date'
                placeholder='Data inicio'
                name='dateFrom'
                value={dates.dateFrom}
                onChange={setValues}
              />
            </FormField>
          </Pane>
          <Pane flex={1} alignItems="center" display="flex">
            <FormField
              label='Data Término'
            >
              <TextInput
                type='date'
                placeholder='Data inicio'
                name='dateTo'
                onChange={setValues}
                value={dates.dateTo}
              />
            </FormField>
          </Pane>
          <Pane flex={1} alignItems="center" display="flex">
            <Button marginLeft={16} marginTop={20} iconBefore="search"
              onClick={() => searchSummary()} > Consultar </Button>
          </Pane>
        </Pane>
      </div>
      {summary.length > 0 && (
        <Table style={{ marginRight: 10, marginLeft: 10, marginTop: 20 }}>
          <Table.Head>
            <Table.TextHeaderCell>
              Funcionário
          </Table.TextHeaderCell>
            <Table.TextHeaderCell>
              Quantidade Atividades
          </Table.TextHeaderCell>
            <Table.TextHeaderCell>
              Quantidade Despesas
          </Table.TextHeaderCell>
            <Table.TextHeaderCell>
              Detalhar
          </Table.TextHeaderCell>

          </Table.Head>
          <Table.Body height={600}>
            {summary.map(expense => (
              <Table.Row key={expense.employeeId}>
                <Table.TextCell >{expense.name}</Table.TextCell>
                <Table.TextCell>{expense.resources}</Table.TextCell>
                <Table.TextCell>{expense.expenses}</Table.TextCell>
                <Table.TextHeaderCell>
                  <Icon icon='search' size={20} onClick={() => {
                    history.push({
                      pathname: `/activities/list/${expense.employeeId}`,
                      state: {
                        employeeName: expense.name,
                        dates
                      }
                    })
                  }} />
                </Table.TextHeaderCell>
              </Table.Row>
            ))}
            <Table.Row style={{
              backgroundColor: '#F5F6F7'
            }}>
              <Table.TextHeaderCell> Total </Table.TextHeaderCell>
              <Table.TextHeaderCell flexBasis={0}>{totalActivities}</Table.TextHeaderCell>
              <Table.TextHeaderCell >{totalExpenses}</Table.TextHeaderCell>
              <Table.TextHeaderCell >{""}</Table.TextHeaderCell>
            </Table.Row>
          </Table.Body>
        </Table >
      )}


    </React.Fragment>
  )
}

export default withRouter(Home)
